import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OrganizationViewModel } from '../models/organization.model';
import { Result } from '@shared/models/result.model';
import { ENDPOINTS } from '@shared/util/constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  constructor(private http: HttpClient) {}

  get(id: string) {
    return this.http.get<Result<OrganizationViewModel | undefined>>(
      `${environment.api}${ENDPOINTS.organizations}/${id}`
    );
  }
}
